import {TxtSelMgr} from "back/edit/wed/features/txtSel";
import {IJmlSet} from "lib/commons/xml/jml";
import {IXAddr, XA} from "lib/commons/xml/xAddr";
import {XmlBatch, XmlDeleteMsg, XmlInsertMsg} from "lib/edit/ot/xmlHouse";
import {SkNode} from "lib/edit/schema/schema";
import {ISkImporter, OSkImportCtxInternal, OSkPasteContext, SkImpBase} from "lib/edit/schema/schemaMeta";
import {LogicRow, MergedCell, OSkTableImportContext, SkMTxtCell, SkMTxtCol, SkMTxtRow, SkMTxtTable} from "lib/edit/schema/schemaMetaTxt";

/** Def module pour import dynamique. */
export type ITryImportInTable = {
	tryImportInTable(this: void, skMTable: SkMTxtTable, ctx: OSkImportCtxInternal & OSkTableImportContext, content: Node, cache: any): Promise<ISkImporter[]>
}

export async function tryImportInTable(this: void, skMTable: SkMTxtTable, ctx: OSkImportCtxInternal & OSkTableImportContext, content: Node, cache: any): Promise<ISkImporter[]> {
	//Import de cellules de tableaux.
	const known = await skMTable.findKnownNodes(ctx, content, true, cache);
	if (!known) return null;
	const cols: Element[] = [];
	const rows: Element[] = [];
	for (const node of known.nodes) {
		const subRule = ctx.skNode.rule.contentRule.findRuleNodeFor(node);
		if (subRule && subRule.skMeta instanceof SkMTxtCol) {
			cols.push(node as Element);
		} else if (subRule && subRule.skMeta instanceof SkMTxtRow) {
			rows.push(node as Element);
		}
	}
	return rows.length > 0 && cols.length > 0 ? [new SkImpTableReplaceCell(ctx, cols, rows)] : null;
}

/** Import de cellules de tableau. */
class SkImpTableReplaceCell extends SkImpBase {

	cols: Element[];
	rows: Element[];

	constructor(ctx: OSkImportCtxInternal & OSkTableImportContext, cols: Element[], rows: Element[], malus = 0) {
		super(ctx.schemaDom);
		this.cols = cols;
		this.rows = rows;
		this.malus = malus;
	}

	getLabel(): string {
		return "Remplacer le contenu des cellules";
		// switch (this.importMode) {
		// case 'replace' :
		// 	return "Remplacer le contenu des cellules";
		// case 'insCol' :
		// 	return "Insérer des colonnes";
		// case 'insRow' :
		// 	return "Insérer des lignes";
		// case 'insColAfter' :
		// 	return "Insérer des colonnes en fin de tableau";
		// case 'insRowAfter' :
		// 	return "Insérer des lignes en fin de tableau";
		// }
		// return "???";
	}

	doImport(ctx: OSkPasteContext & OSkTableImportContext, batch: XmlBatch): void {
		batch.setMeta(TxtSelMgr.MSGMETA_tblLayout, true);
		const table = XA.findDomContainer(ctx.sel.start, this.schemaDom.nodeRoot) as Element;
		let skCellTarget = this.schemaDom.getSkNode(XA.findDomLast(ctx.cellInsertPoint, this.schemaDom.nodeRoot));
		let firstColTarget: number;
		const rowTarget = skCellTarget.node.parentElement as Element;
		let ch = table.firstElementChild;
		let skCh = this.schemaDom.getSkNode(ch);
		let logicRow: LogicRow;
		while (ch) {
			const skChM = skCh.rule.skMeta;
			if (skChM instanceof SkMTxtRow) {
				logicRow = skChM.buildLogicRow(skCh, logicRow);
				if (rowTarget === ch) {
					//on a trouvé la 1ère row d'import.
					firstColTarget = logicRow.indexOf(skCellTarget);
					break;
				}
			}
			ch = ch.nextElementSibling;
			skCh = this.schemaDom.getSkNode(ch);
		}
		if (!ch || firstColTarget < 0) return;
		let colIdx = firstColTarget;
		let insertXa: IXAddr;
		for (const row of this.rows) {
			for (let ch = row.firstElementChild; ch && skCellTarget;) {
				const skNodeFrom = this.schemaDom.getSkNode(ch);
				if (skNodeFrom && skNodeFrom.rule.skMeta instanceof SkMTxtCell) {
					const start = (skCellTarget.rule.skMeta as SkMTxtCell).getOffsetAfterMeta(skCellTarget);
					insertXa = XA.append(XA.fromNode(skCellTarget.node), start);
					batch.add(new XmlDeleteMsg().init(insertXa, skCellTarget.node.childNodes.length - start));
					const jml: IJmlSet = [];
					skNodeFrom.rule.skMeta.exportContent(skNodeFrom, jml);
					batch.add(new XmlInsertMsg().init(insertXa, jml));
				}
				//cell suivante
				ch = ch.nextElementSibling;
				while (logicRow[++colIdx] instanceof MergedCell && !(logicRow[colIdx] as MergedCell).isMaster) ;
				skCellTarget = logicRow[colIdx] instanceof MergedCell ? (logicRow[colIdx] as MergedCell).ownerCell : logicRow[colIdx] as SkNode;
			}
			//Row suivante
			ch = ch.nextElementSibling;
			if (!ch) break;
			skCh = this.schemaDom.getSkNode(ch);
			const skChM = skCh.rule.skMeta;
			if (!(skChM instanceof SkMTxtRow)) break;
			logicRow = skChM.buildLogicRow(skCh, logicRow);
			//Recherche la cell après firstColTarget
			colIdx = firstColTarget;
			while (logicRow[colIdx] instanceof MergedCell && !(logicRow[colIdx] as MergedCell).isMaster) colIdx++;
			skCellTarget = logicRow[colIdx] instanceof MergedCell ? (logicRow[colIdx] as MergedCell).ownerCell : logicRow[colIdx] as SkNode;
		}
		//console.log("setSelAfter:::::", ctx.cellInsertPoint, insertXa);
		const lastCell = XA.subXa(insertXa, -1);
		batch.setSelBefore(ctx.cellInsertPoint, lastCell);
		batch.setSelAfter(ctx.cellInsertPoint, lastCell);
	}
}
